export default __webpack_public_path__ + "static/media/gallery-wip-3D-model_00.f3fafb80.jpg";